/**
 * Boas-vindas aberta pelo menu Conta › O que há de novo: sempre do primeiro cartão, sem abrir
 * "Complete seu perfil" depois. A abertura automática (primeiro acesso de quem vem da Classic)
 * é do OnboardingHost.
 */
import { create } from 'zustand';

interface BoasVindasState {
  peloMenu: boolean;
  abrirPeloMenu: () => void;
  fechar: () => void;
}

export const useBoasVindasStore = create<BoasVindasState>((set) => ({
  peloMenu: false,
  abrirPeloMenu: () => set({ peloMenu: true }),
  fechar: () => set({ peloMenu: false }),
}));
